/**
 * @author Madhuri <sai.madhuri@314ecorp.com>
 * @description React Hook useValidateBatchEligibilityResubmission
 */
import _ from 'lodash';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { BATCH_RESUBMIT_ADF_FIELD_MAP } from 'utils/adfUtils';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';

/**
 * useValidateBatchEligibilityResubmission
 * @returns {UseQueryResult} useValidateBatchEligibilityResubmission
 */

const useValidateBatchEligibilityResubmission = (
	queryModel: EligibilityRequests.IBatchValidation,
	options?: IQueryOptions,
): UseQueryResult<EligibilityRequests.IBatchValidateResponse, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.batchResubmission, queryModel],
		queryFn: async () => {
			const { data } = await api.EzapiApi.validateBatchResubmitEligibilityRequest({
				batchEligibilityResubmitQueryModel: updateApiParamsCriteria(_.cloneDeep(queryModel), BATCH_RESUBMIT_ADF_FIELD_MAP),
			});
			return data;
		},
		...options,
	});
};
export default useValidateBatchEligibilityResubmission;
